import "../../chunk-7QVYU63E.js";
var TeamRole = /* @__PURE__ */ function(TeamRole2) {
  TeamRole2["Admin"] = "admin";
  TeamRole2["Developer"] = "developer";
  TeamRole2["Viewer"] = "viewer";
  return TeamRole2;
}({});
const ROLE_LABELS = {
  ["admin"]: "Admin",
  ["developer"]: "Developer",
  ["viewer"]: "Viewer"
};
const LEGACY_ROLES = [
  "admin",
  "developer"
];
const RBAC_ROLES = [
  ...LEGACY_ROLES,
  "viewer"
];
export {
  LEGACY_ROLES,
  RBAC_ROLES,
  ROLE_LABELS,
  TeamRole
};
//# sourceMappingURL=teamRole.js.map